import { EnvironmentTypes, currentEnvironment } from "../../environment";

const featureFlags = {
  caseStudiesMenuItem: [
    EnvironmentTypes.DEVELOPMENT,
    EnvironmentTypes.TESTING,
    EnvironmentTypes.STAGING,
    EnvironmentTypes.PRODUCTION,
  ].includes(currentEnvironment),
  partnersMenuItem: [
    EnvironmentTypes.DEVELOPMENT,
    EnvironmentTypes.TESTING,
    EnvironmentTypes.STAGING,
    EnvironmentTypes.PRODUCTION,
  ].includes(currentEnvironment),
};

export default featureFlags;
